// 吃瓜导航指南站 - 站内演示内容数据
// 说明：这里用于展示站点结构与交互样式，均为示意数据。

export interface AddressItem {
  id: string;
  tag: string; // 主站 / 备用一号 / 备用二号
  name: string;
  desc: string;
  status: "可用" | "维护中" | "待验证" | "备用";
  speed: string;
  upd: string;
}

export const addressList: AddressItem[] = [
  { id: "a1", tag: "主站入口", name: "今日瓜田 · 主站", desc: "更新最快，内容最全，推荐作为首选收藏。", status: "可用", speed: "约 32ms", upd: "刚刚更新" },
  { id: "a2", tag: "备用一号", name: "今日瓜田 · 镜像A", desc: "与主站实时同步，主站繁忙时可无缝切换。", status: "可用", speed: "约 58ms", upd: "5 分钟前" },
  { id: "a3", tag: "备用二号", name: "今日瓜田 · 镜像B", desc: "独立线路，更适合晚间高峰期追更。", status: "备用", speed: "约 76ms", upd: "12 分钟前" },
  { id: "a4", tag: "备用三号", name: "今日瓜田 · 镜像C", desc: "静态缓存节点，只看热榜与快讯时首选。", status: "维护中", speed: "约 210ms", upd: "2 小时前" },
  { id: "a5", tag: "备用四号", name: "今日瓜田 · 加速D", desc: "全球加速节点，海外访问更顺畅。", status: "可用", speed: "约 49ms", upd: "8 分钟前" },
  { id: "a6", tag: "备用五号", name: "今日瓜田 · 存档E", desc: "历史内容与专题存档，适合回看旧瓜。", status: "待验证", speed: "待测", upd: "1 天前" },
];

export interface SwitchStep {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export const switchSteps: SwitchStep[] = [
  { step: "第 1 步", title: "先把地址存好", desc: "把主站和几个备用地址都加入书签，放在同一个文件夹，命名统一、带上编号，日后随手就能找到。", icon: "ri-bookmark-line" },
  { step: "第 2 步", title: "记住切换顺序", desc: "遇到打不开时，从主站 → 备用一号 → 备用二号依序尝试，别重复点同一个，避免在坏链接上耗时间。", icon: "ri-arrow-left-right-line" },
  { step: "第 3 步", title: "做一次可用检测", desc: "打开前先看速度与更新标记，优先选『可用』和最近更新的入口，能开的概率更高、加载也更稳。", icon: "ri-radar-line" },
  { step: "第 4 步", title: "随手更新备用", desc: "一旦某个新入口能用，顺手把它升级为主用并重新排序，保持你的地址清单始终是最优的一套。", icon: "ri-refresh-line" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  { q: "为什么要多准备几个备用地址？", a: "网站偶尔会因访问量大、线路波动或维护等原因暂时无法打开。多准备几个地址互换，等于多留几条路，哪个能开就用哪个，追更基本不断档。" },
  { q: "主站打不开时，第一个该切哪个？", a: "按顺序切。先试备用一号，再试备用二号。通常相邻编号的镜像同步最快，一般切到第二个就已经能正常打开了。" },
  { q: "如何快速判断哪个地址真的能用？", a: "看两个信号：一是页面标注的『可用』状态，二是更新时间。最近几分钟内同步过、且没有『维护中』提示的地址，能开的概率最大。" },
  { q: "多地址互换会不会弄乱我的收藏？", a: "不会。只要把全部地址放进同一个文件夹、统一编号命名，平时只用主站，出问题时按编号往下切，逻辑很清晰。" },
  { q: "切来切去还是打不开，怎么办？", a: "先清空浏览器缓存或换用无痕窗口再试一次；仍不行就隔几分钟回来。高峰期偶尔会慢，稍等即可，没必要反复狂点。" },
  { q: "备用地址需要每天检查吗？", a: "不需要每天。大约每周做一次可用检测、顺手升级最近能用的新入口即可，保持清单常新就好。" },
];

export interface ChecklistItem {
  title: string;
  desc: string;
  icon: string;
}

export const checkList: ChecklistItem[] = [
  { title: "打开速度快不快", desc: "点开后能快速加载出页面与内容，而不是长时间转圈或直接超时。", icon: "ri-speed-up-line" },
  { title: "内容是否新鲜", desc: "榜单、快讯保持在合理的新鲜度，说明线路在持续同步，值得长期用。", icon: "ri-plant-line" },
  { title: "状态标记要看清", desc: "看到『维护中』或『待验证』就先跳过，优先选明确标注『可用』的入口。", icon: "ri-error-warning-line" },
  { title: "连续体验是否稳定", desc: "连续打开几次都顺畅、不弹错误页，才说明这条线路当下真的稳定可靠。", icon: "ri-shield-check-line" },
];